import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import HistoryOption from './HistoryOption'
import InformationOption from './InforamationOption'
import FoldableOption from './FoldableOption'
import Modal from '../../../../components/Modal'
import {formatDate, isArray} from '../../../../utils/utils'
import Button from '../../../../components/Button'


function NotificationsModal(props) {

    if (props.data.length > 0) {
        const data = props.data[0]
        return (
            <Modal onOutsideClick={() => {}}>
                <StyledNotificationsModal open={props.isOpen} className={props.className}>
                    <div className='top'>
                        <div className='header'>
                            <div className='back' onClick={props.deleteModal}>
                                <i className='fas fa-arrow-left'/>
                            </div>
                            <div className='name'>{data?.fio}</div>
                            <div className='close'></div>
                        </div>
                        <div className='content'>
                            <div className='content-info'>
                                <div className="status">
                                    <b>Статус:</b>
                                </div>
                                <div className="date">
                                    <b>Обращение:</b>
                                    {moment(data?.date).format("YYYY-MM-DD HH:mm")}
                                </div>
                            </div>
                            <div className="list">
                                <FoldableOption isOpen={true} title={"Тикет обращения:"}>
                                    #{data?.ticket_id}
                                </FoldableOption>
                                <FoldableOption isOpen={true} title={"Роль:"}>
                                    {data?.role}
                                </FoldableOption>
                                <FoldableOption isOpen={true} title={"Тип обращения:"}>
                                    {data?.type}
                                </FoldableOption>
                                <FoldableOption isOpen={true} title={"Информация:"}>
                                    <InformationOption type="ФИО" prev={isArray(data?.info[0]?.fio) || "Не указано"}
                                                       next={isArray(data?.info[1]?.fio)}/>
                                    <InformationOption type="Дата рождения"
                                                       prev={data?.info[0]?.dob ? formatDate(data?.info[0]?.dob) : "Не указано"}
                                                       next={data?.info[1]?.dob && formatDate(data?.info[1]?.dob)}/>
                                    <InformationOption type="Мед книжка" prev={data?.info[0]?.med_book || "Не указано"}
                                                       next={data?.info[1]?.med_book}/>
                                    <InformationOption type="СНИЛС" prev={data?.info[0]?.snils || "Не указано"}
                                                       next={data?.info[1]?.snils}/>
                                    <InformationOption type="Адрес" prev={data?.info[0]?.address || "Не указано"}
                                                       next={data?.info[1]?.address}/>
                                    {/*<DocumentsCarousel onClick={props.setImage} images={[]}/>*/}
                                </FoldableOption>
                                <FoldableOption isOpen={false} title={"История:"}>
                                    {data?.history?.map(item => (
                                        <HistoryOption status={item.status === 'approved'}
                                                       type={item.type}
                                                       onClick={_ => props.addModal(item.id)}
                                                       date={moment(item.created_at).format("YYYY-MM-DD HH:mm")}
                                        />
                                    ))}
                                </FoldableOption>

                            </div>
                        </div>
                        <div className="bottom">
                            {
                                props.data.length === 1 && (data.status === 'В ожидании' || data.status === 'В работе') && (
                                    <div className='buttons'>
                                        <Button onClick={_ => props?.disagree(data.id, data.user_id)} text={'Отклонить'}
                                                color={'red'}/>
                                        <Button onClick={_ => props?.agree(data.id, data.user_id)} text={'Одобрить'}/>
                                    </div>
                                )
                            }
                        </div>

                    </div>
                </StyledNotificationsModal>

            </Modal>
        );
    } else return <></>

}


const StyledNotificationsModal = styled.div`
  height: 100%;
  width: ${p => p.open ? "660px" : '0'};
  background: white;
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  padding-top: 90px;
  padding-left: 50px;
  padding-right: 50px;
  overflow: auto;
  justify-content: space-between;

  .top {
    width: 100%;
    display: flex;
    flex-direction: column;

    .header {
      width: 100%;
      display: flex;

      .back {
        margin-right: 20px;
        font-size: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
      }

      .name {
        width: 100%;
        font-size: 26px;
        font-weight: bold;
      }

      .close {
        width: 20px;
        height: 20px;
      }
    }

    .content {
      margin-top: 70px;


      .content-info {
        margin-bottom: 40px;
        font-size: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        b {
          margin-right: 5px;
        }

        .date {
          font-weight: normal;
        }
      }
    }
  }

  .bottom {
    width: 100%;

    .buttons {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 100px;
    }

  }

  @media (max-width: 1100px) {
    width: 100%;
    height: 100%;
    zoom: 0.85;
  }
`

export default NotificationsModal;